import { useState, useCallback } from 'react';

interface SelectModalConfig {
    show: boolean;
    screenId: string;
    fieldCode: string;
    title: string;
    screenData?: any;
}

interface UseSelectModalReturn {
    selectModalConfig: SelectModalConfig | null;
    openSelectModal: (field: any, screenColumns?: any[]) => void;
    closeSelectModal: () => void;
    handleSelectModalSelect: (row: any, displayValue: string, onSelect?: (fieldCode: string, rowId: any, displayValue: string) => void) => void;
}

export const useSelectModal = (): UseSelectModalReturn => {
    const [selectModalConfig, setSelectModalConfig] = useState<SelectModalConfig | null>(null);

    const openSelectModal = useCallback((field: any, screenColumns?: any[]) => {
        if (field.screenId) {
            let screenData: any = undefined;
            if (screenColumns && field.screenColumnId) {
                const column = screenColumns.find((col: any) => col.id === field.screenColumnId);
                if (column?.relatedScreen && String(column.relatedScreen.id) === String(field.screenId)) {
                    screenData = column.relatedScreen;
                }
            }
            setSelectModalConfig({
                show: true,
                screenId: field.screenId,
                fieldCode: field.code,
                title: field.displayName,
                screenData
            });
        }
    }, []);

    const closeSelectModal = useCallback(() => {
        setSelectModalConfig(null);
    }, []);

    const handleSelectModalSelect = useCallback((
        row: any,
        displayValue: string,
        onSelect?: (fieldCode: string, rowId: any, displayValue: string) => void
    ) => {
        if (selectModalConfig && onSelect) {
            onSelect(selectModalConfig.fieldCode, row.id, displayValue);
        }
        setSelectModalConfig(null);
    }, [selectModalConfig]);

    return {
        selectModalConfig,
        openSelectModal,
        closeSelectModal,
        handleSelectModalSelect
    };
};
